import "./App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import NotFound from "./Components/Main/NotFound/NotFound";
import Home from "./Components/Main/Home/Home";
import MaintenanceItems from "./Components/Collective/MaintenanceItems/MaintenanceItems";
import MaintenanceItem from "./Components/individual/MaintenanceItem/MaintenanceItem";
import AddMaintenanceItem from "./Components/Create/AddMaintenanceItem/AddMaintenanceItem";
import UpdateMaintenanceItem from "./Components/Update/UpdateMaintenanceItem/UpdateMaintenanceItem";
import MaintenanceSchedules from "./Components/Collective/MaintenanceSchedules/MaintenanceSchedules";
import MaintenanceSchedule from "./Components/individual/MaintenanceSchedule/MaintenanceSchedule";
import AddMaintenanceSchedule from "./Components/Create/AddMaintenanceSchedule/AddMaintenanceSchedule";
import UpdateMaintenanceSchedule from "./Components/Update/UpdateMaintenanceSchedule/UpdateMaintenanceSchedule";
import Contracts from "./Components/Collective/Contracts/Contracts";
import Contract from "./Components/individual/Contract/Contract";
import AddContract from "./Components/Create/AddContact/AddContract";
import UpdateContract from "./Components/Update/UpdateContract/UpdateContract";
import Tasks from "./Components/Collective/Tasks/Tasks";
import TaskProfile from "./Components/individual/TaskProfile/TaskProfile";
import Companies from "./Components/Collective/Companies/Companies";
import CompanyProfile from "./Components/individual/CompanyProfile/CompanyProfile";
import Registration from "./Components/Main/Regestration/Registration";
import Signin from "./Components/Main/Signin/Signin";
import Profile from "./Components/Main/Profile/Profile";
import Navbar from "./Components/Frequent/Navbar/Navbar";
import Aside from "./Components/Frequent/Aside/Aside";
import { useContext, useState } from "react";
import Footer from "./Components/Frequent/Footer/Footer";
import AddCompany from "./Components/Create/AddCompany/AddCompany";
import AddBranch from "./Components/Create/AddBranch/AddBranch";
import { ToastContainer } from "react-toastify";
import { AuthContext } from "./context/AuthContext";
import { ProtectedRoutes } from "./hooks/ProtectRoutes";
import User from "./Components/Collective/Users/User";
import AddMaintenanceType from "./Components/Create/AddMaintenanceType/AddMaintenanceType";
import MaintenanceTypes from "./Components/Collective/MaintenanceTypes/MaintenanceTypes";
import AddContractTerms from "./Components/Create/AddContractTerms/AddContractTerms";
import TermsContract from "./Components/Collective/TermsContract/TermsContract";
import StatusMaintenanceItems from "./Components/Collective/StatusMaintenanceItems/StatusMaintenanceItems";
import MaintenanceItemsDatatable from "./Components/Collective/MaintenanceItems/MaintenanceItemsDatatable";
import { ROLES } from "./constants/roles";
import AddMaintenanceItemContract from "./Components/Create/AddMaintenanceItemContract/AddMaintenanceItemContract";
import AddMangerAndStuff from "./Components/Create/AddMangerAndStuff/AddMangerAndStuff";
import MaintenanceSchedulesTable from "./Components/MaintenanceSchedules/MaintenanceSchedulesTable";
// import Verification from "./Components/Main/Regestration/Verification";


function App() {
  const [activeAside, setActiveAside] = useState(false);
  const [darkMode, setDarkMode] = useState(localStorage.getItem("darkMode") === "true");
  const [isSignin, setIsSignin] = useState(true);
  const { user, token } = useContext(AuthContext);
  const [id, setId] = useState(null);
  const [name, setName] = useState(null);
  const navigate = useNavigate();
  const handleChangeState = (id, name) => {
    setId(id);
    setName(name);
    navigate("/UpdateMaintenanceType");
  };
  function toggleAside() {
    setActiveAside(!activeAside);
    console.log("activeAside", activeAside);
  }

  function toggleDarkMode() {
    localStorage.setItem("darkMode", !darkMode);
    setDarkMode(!darkMode);
  }

  function signin() {
    localStorage.setItem("signin", true);
    setIsSignin(true);
  }

  return (
    <>
      <div className={darkMode ? "dark min-vh-100 body" : "min-vh-100 body"}>
        <ToastContainer />
        <main className="position-relative d-flex flex-wrap">
          {user && (
            <>
              <header className="w-100 position-relative">
                <div className="position-absolute top-0 bottom-0 start-0 end-0 Headerlayer">
                  <Navbar
                    toggleAside={toggleAside}
                    toggleDarkMode={toggleDarkMode}
                  />
                </div>
              </header>
              <Aside
                activeAside={activeAside}
                // asideRef={asideRef}
                // asideHeight={asideHeight}
              />
            </>
          )}
          <Routes>
            <Route path="/Registration" element={<Registration />} />
            <Route path="/Signin" element={<Signin />} />
            <Route path="/Signin" element={<Signin />} />
            {/* <Route path="/verification" element={<Verification />} /> */}
            <Route
              element={<ProtectedRoutes role={[ROLES.OWNER, ROLES.MANAGER]} />}
            >
              <Route path="/AddCompany" element={<AddCompany />} />
              <Route path="/" element={<Home />} />
              <Route path="/Home" element={<Home />} />
              <Route path="/MaintenanceItems" element={<MaintenanceItems />} />
              <Route
                path="/MaintenanceItems/MaintenanceItem/:itemId"
                element={<MaintenanceItem />}
              />
              <Route
                path="/AddMaintenanceItem"
                element={<AddMaintenanceItem />}
              />
              <Route
                path="/EditMaintenanceItem/:itemId"
                element={<AddMaintenanceItem />}
              />
              <Route
                path="/UpdateMaintenanceItem"
                element={<UpdateMaintenanceItem />}
              />
              <Route
                path="/MaintenanceSchedules"
                element={<MaintenanceSchedules />}
              />
              <Route
                path="/ShowMoreMaintenanceSchedule/:ScheduleId"
                element={<AddMaintenanceSchedule />}
              />
              <Route
                path="Contracts/:ContractId/MaintenanceSchedules"
                element={<MaintenanceSchedules />}
              />
              <Route
                path="/AddMaintenanceSchedule"
                element={<AddMaintenanceSchedule />}
              />
              {/* <Route path="/MaintenanceSchedules/:ScheduleId" element={<MaintenanceSchedule />} /> */}
              {/* <Route path="/AddMaintenanceSchedule/:ScheduleId" element={<AddMaintenanceSchedule />} /> */}
              {/* <Route path="Contracts/:ContractId/AddStandardMaintenanceItem" element={<AddMaintenanceSchedule />} /> */}

              <Route
                path="/AddMaintenanceSchedule/:ScheduleId"
                element={<AddMaintenanceItemContract />}
              />
              <Route
                path="Contracts/:ContractId/AddStandardMaintenanceItem"
                element={<AddMaintenanceItemContract />}
              />
              <Route
                path="contracts/addMangerAndStuff/:ContractId"
                element={<AddMangerAndStuff />}
              />
              <Route
                path="/MaintenanceSchedules/addMangerAndStuff/:ScheduleId"
                element={<AddMangerAndStuff />}
              />

              <Route
                path="/UpdateMaintenanceSchedule"
                element={<UpdateMaintenanceSchedule />}
              />
              <Route path="/Contracts" element={<Contracts />} />
              <Route path="/users" element={<User />} />
              <Route
                path="/Contracts/Contract/:ContractId"
                element={<Contract />}
              />
              <Route path="/AddContract" element={<AddContract />} />
              <Route
                path="/editContract/:ContractId"
                element={<AddContract />}
              />
              <Route path="UpdateContract" element={<UpdateContract />} />
              <Route path="/Companies" element={<Companies />} />
              <Route
                path="/Companies/Company/:CompanyId"
                element={<CompanyProfile />}
              />
              <Route
                path="/addMaintenanceType"
                element={<AddMaintenanceType />}
              />
              <Route
                path="/editMaintenanceType/:id"
                element={<AddMaintenanceType />}
              />
              <Route
                path="/allMaintenanceType"
                element={<MaintenanceTypes />}
              />
              <Route path="/addContractTerms" element={<AddContractTerms />} />
              <Route
                path="/editContractTerms/:id"
                element={<AddContractTerms />}
              />
              <Route path="/allContractTerms" element={<TermsContract />} />
              <Route path="/AddBranch" element={<AddBranch />} />
              <Route
                path="/reports"
                element={<MaintenanceSchedulesTable />}
              />
            </Route>
            <Route
              element={
                <ProtectedRoutes
                  role={[ROLES.MANAGER, ROLES.OWNER, ROLES.STAFF]}
                />
              }
            >
              <Route
                path="/MaintenanceSchedules/show/:ScheduleId"
                element={<MaintenanceItemsDatatable />}
              />
              <Route
                path="/MaintenanceSchedules/:ScheduleId/updateMaintenanceItem"
                element={<MaintenanceSchedule />}
              />
              <Route path="/Tasks" element={<Tasks />} />
              <Route path="Task/:TaskId" element={<TaskProfile />} />
              <Route path="/Profile" element={<Profile />} />
              <Route
                path="/MaintenanceSchedules/:ScheduleId/statusMaintenanceItem"
                element={<StatusMaintenanceItems />}
              />
            </Route>

            <Route path="/NotFound" element={<NotFound />} />
            {/* <Route path="*" element={<NotFound />} /> */}
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;
